import {
  FETCH_ALL_ARGUMENT_BEGIN,
  FETCH_ALL_ARGUMENT_SUCCESS,
  FETCH_ALL_ARGUMENT_FAILURE,
  FETCH_ALL_ARGUMENT_RESET_DEFAULT_FILTER,
  FETCH_ALL_ARGUMENT_SET_FILTER
} from "redux/action/actionTypes";
import { TableFilters } from "component/Base/Helper";

const initialState = {
  data: [],
  filter: TableFilters.defaultArgumentFilter,
  loading: false,
  error: null
};

export default function argumentFetchReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_ARGUMENT_BEGIN:
      return {
        ...state,
        filter: action.filter,
        loading: true
      };

    case FETCH_ALL_ARGUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        total: action.total
      };

    case FETCH_ALL_ARGUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FETCH_ALL_ARGUMENT_RESET_DEFAULT_FILTER:
      return {
        ...state,
        loading: false,
        data: [],
        filter: action.filter
      };

    case FETCH_ALL_ARGUMENT_SET_FILTER:
      return {
        ...state,
        loading: false,
        data: [],
        filter: action.filter
      };

    default:
      return state;
  }
}
